import React, { useState } from "react";
import styles from "./PropertiesBox.module.css";
import { determinant, EigenvalueDecomposition, Matrix} from "ml-matrix";
import { OPERATION_TYPE } from "../../constants";
import MatrixGrid from "../matrixGrid/MatrixGrid";

//function to round number to at most 3 decimal places, only if necessary
function roundToThree(num) {
    return (Math.round((num + Number.EPSILON) * 1000) / 1000)
}

const PropertiesBox = () => {
    const [operation, setOperation] = useState(OPERATION_TYPE.DETERMINANT);
    const columns = 3;
    const rows = 3;

    const [matrix, setMatrix] = useState(new Matrix(rows, columns));

    const handleSubmit = e => {
        e.preventDefault();
    }
    return (
        <div className={styles.box_wrapper}>
            <p className={styles.operation_text}>
                <mark className={styles.highlight}>Select the matrix property you want to operate with:
                    <select className={styles.selection_box} value={operation.getCode()} onChange={e => setOperation(OPERATION_TYPE.fromCode(e.target.value))}>
                        <option value={4}>Determinant</option>
                        <option value={5}>Eigenvalues</option>
                        <option value={6}>Eigenvector</option>
                    </select>
                </mark></p>
            <p className={styles.operation_text}>Calculate the <b>{operation.toString()}</b> of the matrix shown below:</p>
            <MatrixGrid matrix={matrix} setMatrix={setMatrix} editable={true}/>
            <p className={styles.result_text}>
                {operation === OPERATION_TYPE.DETERMINANT &&
                    <p>
                        The determinant is: <b>{roundToThree(determinant(matrix))}</b>
                    </p>
                }
                {operation === OPERATION_TYPE.EIGENVALUES &&
                    <p>The eigenvalues are:
                        {(new EigenvalueDecomposition(matrix)).realEigenvalues.map((eigenvalue, index) =>
                            <p>λ<sub>{index}</sub> : <b>{roundToThree(eigenvalue)}</b></p>)}
                    </p>
                }
                {operation === OPERATION_TYPE.EIGENVECTORS &&
                    <p>The eigenvectors are:
                        {(new EigenvalueDecomposition(matrix)).eigenvectorMatrix.data.map(row =>
                        <p>
                            <span className={styles.eigenvector_styling}>
                                {roundToThree(row[0])}
                            </span> <span className={styles.eigenvector_styling2}>
                                {roundToThree(row[1])}
                            </span> <span className={styles.eigenvector_styling}>
                                {roundToThree(row[2])}
                            </span>
                        </p>)}
                    </p>
                }
            </p>
        </div>
    );
}
    ;

export default PropertiesBox;